import { useQuery } from "@tanstack/react-query";
import { getConnectorsApiIngestionConnectorsGet } from "@noa/api-core";
import { UploadQueryKey } from "../../query-keys";

/**
 * Which connector sources (Maximo, SharePoint, ConformIT, Google Drive) have credentials
 * configured on the backend. Configuration only changes with a deployment, so
 * the result is never considered stale.
 */
export function useConnectors() {
  const { data, isPending } = useQuery({
    queryKey: UploadQueryKey.connectors(),
    queryFn: async () => {
      const { data } = await getConnectorsApiIngestionConnectorsGet({ throwOnError: true });
      return data;
    },
    staleTime: Infinity,
  });

  return { connectors: data, isLoading: isPending };
}
